import React from 'react';
import { Can } from '@casl/react';
import { createMongoAbility } from '@casl/ability';

import { Chip } from 'app/components';
import {
  getBootstrapApp,
  getBusinessArea,
  getUserRoles,
  useAppSelector
} from 'app/redux';
import BAMapping from 'data/mock/businessAreaAndServices.json';
import { IBusinessArea } from 'app/utils';
import { ChipsGroupProps } from './ChipsGroup.interface';

export const ChipsGroup: React.FC<ChipsGroupProps> = ({
  chipElements,
  selected,
  serviceMode,
  onClick
}) => {
  const currentBusinessArea = useAppSelector(getBusinessArea);
  const userPermissions = useAppSelector(getUserRoles);
  const bootstrap = useAppSelector(getBootstrapApp);

  const businessAreas: IBusinessArea =
    bootstrap.businessAreas || BAMapping.businessAreas;

  const enhancedPermissions = [
    ...(userPermissions || []),
    { action: 'view', subject: 'nda-generator' }
  ];

  const ability = createMongoAbility(enhancedPermissions);
  return (
    <>
      {Object.keys(chipElements)?.map((element) => {
        const isDisabled =
          serviceMode && currentBusinessArea !== undefined
            ? !businessAreas[currentBusinessArea].services.includes(element)
            : undefined;

        const icon =
          'icon' in chipElements[element]
            ? chipElements[element].icon
            : undefined;

        const maturity =
          'maturity' in chipElements[element]
            ? chipElements[element].maturity
            : undefined;

        if (isDisabled || !chipElements[element].promote) {
          return null;
        }

        const chip = (
          <Chip
            key={`chip-${element}`}
            icon={icon}
            maturity={maturity}
            id={element}
            value={chipElements[element].name}
            selected={element === selected}
            disabled={!chipElements[element].active}
            onClick={onClick}
          />
        );

        if (chipElements[element].active) {
          return (
            <Can I="view" a={element} ability={ability} key={`can-${element}`}>
              {chip}
            </Can>
          );
        }

        return chip;
      })}
    </>
  );
};
